import {AsyncActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/AsyncActDecorator';

export class LoadDeviceStyleAct extends AsyncActDecorator {
    public async execute(): Promise<void> {
        await this.resourceManager.loadDeviceStyle();
    }

    getName(): string {
        return 'LoadDeviceStyleAct';
    }
}